module.exports = ".avatar-center {\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  height: 130px;\r\n  width: 130px;\r\n  border: lightgray 5px solid;\r\n}\r\n\r\n.line-breaker {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.img-radius-50 {\r\n  border-radius: 50%;\r\n}\r\n\r\n.img-center {\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\nimg {\r\n  vertical-align: middle;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/read-description/read-description.component.css
// module id = ./src/app/shared/components/read-description/read-description.component.css
// module chunks = main